module.exports = __webpack_public_path__ + "img/80ne.32a04c25.svg";